<template>
  <div
    class="bb-popup-info"
    :class="[customClass && `bb-popup-info_${customClass}`]"
    :style="popupStyle"
  >
    {{text}}
  </div>
</template>

<script>
export default {
  name: 'BBPopupInfo',
  props: {
    text: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    popupStyle: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.bb-popup-info {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 4px 7px;
  background: rgba($color-black, 0.55);
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  color: $color-white;
  border-radius: 3px;
  z-index: 20;
  pointer-events: none;
  text-transform: capitalize;
  user-select: none;

  &_type {
    max-width:110px;
    min-width: 110px;
    white-space: inherit;
    text-transform: inherit;
  }

  &:before {
    content: '';
    position: absolute;
    left: auto;
    top: -3px;
    display: block;
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-bottom: 3px solid rgba($color-black, 0.55);
  }

  &_type-big,
  &_type-middle {
    background: rgba($color-black, 0.75);
    white-space: inherit;
    text-transform: inherit;
    word-break: break-word;
    line-height: 16px;

    &:before {
      border-bottom: 3px solid rgba($color-black, 0.75);
    }

  }

  &_type-big {
    max-width: 350px;
    min-width: 350px;


  }
  &_type-middle {
    max-width: 225px;
    min-width: 225px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPopupInfo/BBPopupInfo.vue